import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const MessageList = ({ messages }) => {
    const navigate = useNavigate();

    // --- Theming ---
    const textPrimary = "text-silver-light";
    const textSecondary = "text-silver-medium/80";
    const hoverBg = "bg-gray-800/70";

    if (!messages || messages.length === 0) {
        return <p className={textSecondary}>No messages found.</p>;
    }

    // Function to format date/time nicely
    const formatDateTime = (isoString) => {
        if (!isoString) return 'N/A';
        try {
            return new Date(isoString).toLocaleString(undefined, {
                dateStyle: 'medium',
                timeStyle: 'short',
            });
        } catch (e) {
            return 'Invalid Date';
        }
    };

    // Function to truncate message
    const truncateMessage = (text, maxLength = 50) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + "...";
    };

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-700/50">
                <thead className="bg-gray-900/70">
                    <tr>
                        <th scope="col" className={`py-3.5 pl-4 pr-3 text-left text-sm font-semibold ${textPrimary} sm:pl-6`}>Date/Time</th>
                        <th scope="col" className={`px-3 py-3.5 text-left text-sm font-semibold ${textPrimary}`}>Name</th>
                        <th scope="col" className={`px-3 py-3.5 text-left text-sm font-semibold ${textPrimary}`}>Email</th>
                        <th scope="col" className={`px-3 py-3.5 text-left text-sm font-semibold ${textPrimary}`}>Service</th>
                        <th scope="col" className={`px-3 py-3.5 text-left text-sm font-semibold ${textPrimary}`}>Message</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-800/30 bg-gray-950/50">
                    {messages.map((msg) => (
                        <tr
                            key={msg._id}
                            className={`hover:${hoverBg} transition-colors duration-150 cursor-pointer`}
                            onClick={() => navigate(`/developer/messages/${msg._id}`)}
                        >
                            <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm ${textSecondary} sm:pl-6`}>{formatDateTime(msg.createdAt)}</td>
                            <td className={`whitespace-nowrap px-3 py-4 text-sm font-medium ${textPrimary}`}>{msg.name}</td>
                            <td className={`whitespace-nowrap px-3 py-4 text-sm ${textSecondary}`}>{msg.email}</td>
                            <td className={`whitespace-nowrap px-3 py-4 text-sm ${textSecondary}`}>
                                {msg.service ? (
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-900/30 text-blue-300 border border-blue-800/30">
                                        {msg.service}
                                    </span>
                                ) : 'Not specified'}
                            </td>
                            <td className={`px-3 py-4 text-sm ${textSecondary} max-w-xs break-words`}>
                                {truncateMessage(msg.message)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

MessageList.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        service: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        createdAt: PropTypes.string, // ISO date string
        updatedAt: PropTypes.string,
    })),
};

export default MessageList; 